<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="650"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <div style="margin-bottom: 10px; color: #fa9600">
        *可根据系统提供的模版进行填写后在上传，也可直接进行第二步
      </div>
      <div class="flex-align-center" style="margin-bottom: 10px">
        <span class="title-1">第一步：下载模版</span>
        <a style="margin-left: 10px" :href="templateUrl" @click="isDownload = true">
          下载家校园沟通记录表
        </a>
      </div>
      <a-upload-dragger
        :disabled="false"
        accept=".doc,.docx"
        name="file"
        :file-list="fileList"
        :multiple="true"
        :action="uploadAction"
        :headers="tokenHeader"
        @change="handleChange"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">添加文件</p>
        <p class="ant-upload-hint">(仅支持.doc或.docx格式的文件)</p>
      </a-upload-dragger>
      <div class="title-1" style="margin: 10px 0">第二步：评估</div>
      <a-form-model
        ref="ruleForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item label="班级表现">
          <j-multi-select-tag
            v-model="form.classReflect"
            dictCode="class_performance"
            placeholder="请选择班级表现"
          />
        </a-form-model-item>
        <a-form-model-item label="家庭情况">
          <j-multi-select-tag
            v-model="form.familyCondition"
            dictCode="family_case"
            placeholder="请选择家庭情况"
          />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea
            v-model="form.remarks"
            :auto-size="{ minRows: 5, maxRows: 8 }"
            placeholder="请输入备注"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getStoreFileUrl } from '@/utils/util'
import JMultiSelectTag from '@comp/dict/JMultiSelectTag.vue'
import { postAction, putAction } from '@api/manage'

export default {
  name: 'AssessmentRecord',
  components: { JMultiSelectTag },
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '评估记录',
    },
  },
  data() {
    return {
      visible: false,
      templateUrl: getStoreFileUrl('/schoolEvaluation/中小学心理评估访谈提纲记录表.docx'),
      form: {},
      rules: {},
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=emotionComments',
      fileList: [],
      studentRecordId: '',
    }
  },
  methods: {
    showModal(data) {
      const { id, studentRecordId, classReflect, familyCondition, remarks } = data
      if (studentRecordId) {
        this.studentRecordId = studentRecordId
      }
      this.form = {
        id: studentRecordId,
        recordId: id,
        classReflect,
        studentRecordId,
        familyCondition,
        remarks,
      }
      this.visible = true
      this.fileList = []
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.fileList = []
      this.studentRecordId = ''
    },
    async handleOk() {
      const params = {
        ...this.form,
        recordType: 1,
      }
      console.log('文件信息：', this.fileList)
      if (this.fileList.length) {
        params.attachment = this.fileList[this.fileList.length - 1].url
      }
      const res = this.studentRecordId
        ? await putAction('/studentRecord/edit', params)
        : await postAction('/studentRecord/add', params)
      if (res.success) {
        this.$message.success(res.message)
        this.$emit('refreshData')
        this.hideModal()
      } else {
        this.$message.error(res.message)
      }
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })
      console.log('fileList', fileList)
      this.fileList = fileList
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-body {
    padding: 10px 24px;
  }
}
</style>
